import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import FilesTreeView from 'components/FileManagement/FilesTreeView';
import UploadFilesButton from 'components/FileManagement/UploadFilesButton';
import { selectGroupGuid, useAppSelector } from 'slices/commonSelectors';

type AssetOrgFolderModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Org file-library folder to browse. */
  notefolderId: string | null;
  /** Shown in the title, e.g. "Drawings". */
  folderName: string;
  assetName?: string;
};

/** Browse (and upload into) one of an asset's org library folders. */
export const AssetOrgFolderModal: React.FC<AssetOrgFolderModalProps> = ({
  open,
  onOpenChange,
  notefolderId,
  folderName,
  assetName,
}) => {
  const orgGuid = useAppSelector(selectGroupGuid) as string | undefined;

  return (
    <Dialog open={open && !!notefolderId} onOpenChange={onOpenChange}>
      <DialogContent className="dark tw:flex tw:max-h-[85vh] tw:flex-col tw:overflow-hidden tw:bg-background tw:text-foreground sm:tw:max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            {assetName ? `${assetName} — ${folderName}` : folderName}
          </DialogTitle>
        </DialogHeader>
        {orgGuid && notefolderId ? (
          <div className="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col tw:gap-2 tw:overflow-y-auto">
            <div className="tw:flex tw:justify-end">
              <UploadFilesButton
                ownerId={orgGuid}
                scopeType="organization"
                notefolderId={notefolderId}
                className="button--primary"
                showNotificationText={false}
                showTooltip={false}
              />
            </div>
            <FilesTreeView
              ownerId={orgGuid}
              scopeType="organization"
              rootFolderId={notefolderId}
              showUploadButton={false}
              showCreateFolderButton={false}
              hideSearch
            />
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};
